import React, { useEffect } from "react";
import {
  Route,
  useNavigate,
  useLocation,
  Link,
  Routes,
} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Api from "../../services/api";
import ListCompanies from "../company-data/list-companies";
import CompanyDatapoints from "../company-datapoints/company-datapoints";
import "./index.scss";
import Loader from "../../components/loader/loader";
export function Admin(props) {
  const {
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    getAccessTokenSilently,
    user,
  } = useAuth0();

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      localStorage.setItem("redirectURL", location.pathname);
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, location.pathname, loginWithRedirect])

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently({
        audience: "https://eightfold-data",
      }).then((token) => {
        Api.setToken(token);
        const redirect = localStorage.getItem("redirectURL");
        if (redirect) {
          navigate(redirect)
        }
      });
    }
  }, [isAuthenticated, getAccessTokenSilently, navigate]);
  return (
    <Routes>
      <Route
        path={`/companies`}
        element={<ListCompanies />}
      />
      <Route
        path={`/company/:id`}
        element={<CompanyDatapoints />}
      />
      <Route

      />

      <Route path="/"
        element={
          <div className="h-100 d-flex flex-column justify-content-center align-items-start admin-intro">
            {isAuthenticated && (
              <>
                <h1 className="display-3">
                  Welcome <span className="name">{user.name}</span>
                </h1>
                <Link className="btn btn-primary my-3" to="companies">
                  View Companies
                </Link>
              </>
            )}

            {!isAuthenticated && (
              <>
                {" "}
                <h1 className="display-3 d-flex">
                  <span className="name me-3">Logging you in</span>
                  <Loader />
                </h1>
              </>
            )}
          </div>
        }
      />
    </Routes>
  );
}
